import React, { useEffect, useState } from 'react';
import roller1 from '../assets/rollers/roller.jpg';
import roller2 from '../assets/rollers/roller2.PNG';
import roller3 from '../assets/rollers/roller3.jpg';
import roller4 from '../assets/rollers/roller4.jpg';
import roller5 from '../assets/rollers/roller5.PNG';
import roller6 from '../assets/rollers/roller6.jpg';

const Features = () => {
  const images = [roller1, roller2, roller3, roller4, roller5, roller6];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 3500);

    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <section id='features' className='py-4'>
      <div className='container flex flex-col px-4 mx-auto mt-10 space-y-12 md:space-y-0 md:flex-row'>
        <div className='flex flex-col space-y-12 md:w-1/2 pr-4 pb-4'>
          <h2 className='max-w-md text-2xl font-medium text-center md:text-left'>
            Getting Started with Ajo
          </h2>
          <p className='max-w-sm text-center text-gray-600 md:text-left'>
            With Ajo, users can enjoy secure transactions, transparent operations, and easy access to their savings
            anytime, anywhere.
          </p>

          <div className='relative w-full rounded-xl border border-gray-200 bg-white p-4 shadow-lg'>
            <div className='relative overflow-hidden rounded-lg'>
              <img
                src={images[currentIndex]}
                alt={`Ajo preview ${currentIndex + 1}`}
                className='block h-72 w-full object-cover md:h-80'
                loading='lazy'
              />

              <div className='pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-black to-transparent opacity-25'></div>
              <div className='pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-black to-transparent opacity-25'></div>

              <div className='absolute bottom-3 left-1/2 flex -translate-x-1/2 items-center gap-2 rounded-full bg-black bg-opacity-60 px-3 py-1'>
                {images.map((_, index) => (
                  <button
                    key={index}
                    type='button'
                    onClick={() => setCurrentIndex(index)}
                    aria-label={`Go to image ${index + 1}`}
                    className={`h-2.5 w-2.5 rounded-full transition-all ${
                      index === currentIndex ? 'bg-white' : 'bg-gray-400 hover:bg-gray-200'
                    }`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className='flex flex-col space-y-8 md:w-1/2'>
          <div className='flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row'>
            <div className='rounded-l-full bg-gray-500 md:bg-transparent'>
              <div className='flex items-center space-x-2'>
                <div className='px-4 py-2 text-white rounded-full md:py-1 bg-gray-700'>01</div>
                <h3 className='text-base font-bold md:mb-4 md:hidden'>Smart</h3>
              </div>
            </div>

            <div>
              <h3 className='hidden mb-4 text-lg font-bold md:block'>Smart</h3>
              <p className='text-gray-600'>
                Ajo leverages intelligent features to help users save effectively, track contributions, and manage
                their thrift goals with ease, ensuring financial growth is always within reach.
              </p>
            </div>
          </div>

          <div className='flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row'>
            <div className='rounded-l-full bg-gray-500 md:bg-transparent'>
              <div className='flex items-center space-x-2'>
                <div className='px-4 py-2 text-white rounded-full md:py-1 bg-gray-700'>02</div>
                <h3 className='text-base font-bold md:mb-4 md:hidden'>User-Friendly</h3>
              </div>
            </div>

            <div>
              <h3 className='hidden mb-4 text-lg font-bold md:block'>User-Friendly</h3>
              <p className='text-gray-600'>
                Designed with simplicity in mind, Ajo offers an intuitive interface that makes saving and managing
                funds effortless for individuals and groups alike.
              </p>
            </div>
          </div>

          <div className='flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row'>
            <div className='rounded-l-full bg-gray-500 md:bg-transparent'>
              <div className='flex items-center space-x-2'>
                <div className='px-4 py-2 text-white rounded-full md:py-1 bg-gray-700'>03</div>
                <h3 className='text-base font-bold md:mb-4 md:hidden'>Secure</h3>
              </div>
            </div>

            <div>
              <h3 className='hidden mb-4 text-lg font-bold md:block'>Secure</h3>
              <p className='text-gray-600'>
                Ajo prioritizes your financial safety with advanced encryption and robust security measures, ensuring
                your funds and personal data are always protected.
              </p>
            </div>
          </div>

          <div className='flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row'>
            <div className='rounded-l-full bg-gray-500 md:bg-transparent'>
              <div className='flex items-center space-x-2'>
                <div className='px-4 py-2 text-white rounded-full md:py-1 bg-gray-700'>04</div>
                <h3 className='text-base font-bold md:mb-4 md:hidden'>Powerful</h3>
              </div>
            </div>

            <div>
              <h3 className='hidden mb-4 text-lg font-bold md:block'>Powerful</h3>
              <p className='text-gray-600'>
                Backed by robust technology, Ajo delivers secure, reliable, and scalable solutions, empowering users
                to take control of their financial future with confidence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
